module.exports = __webpack_public_path__ + "img/patch.2ef0c79a.png";